import LogService from "../CommonSdk/LogService";
import * as ErrorUtils from "../Utils/ErrorUtils";
import * as FetchUtils from "../Utils/FetchUtils";

const LOG_TAG = "SANDBOX_SERVER_FETCH";

class SandBoxServerRequest {
    constructor() {
        LogService.trace(LOG_TAG, "constructor");
        this.reset();
    }

    initialise(serverUrl, token) {
        LogService.trace(LOG_TAG, "initialise");
        this.serverUrl = serverUrl;
        this.token = token;
    }

    reset() {
        LogService.trace(LOG_TAG, "reset");
        this.serverUrl = null;
        this.token = null;
    }

    getServerUrl() {
        return this.serverUrl;
    }

    get(relativeUrl) {
        const request = new Request(this.serverUrl + relativeUrl, {
            method: "GET",
            headers: new Headers({
                accept: "application/json",
                authorization: "Bearer " + this.token
            })
        });

        if (this.serverUrl) {
            return fetch(request)
                .then(response => FetchUtils.parseFetchResponse(response))
                .catch(error => Promise.reject(error));
        }
        LogService.error(LOG_TAG, "get", "no server instance");
        return Promise.reject(ErrorUtils.parseErrorAndReturnPayload("no server instance"));
    }

    post(relativeUrl, body) {
        const request = new Request(this.serverUrl + relativeUrl, {
            method: "POST",
            headers: new Headers({
                accept: "application/json",
                "Content-Type": "application/json",
                authorization: "Bearer " + this.token
            }),
            body: body
        });

        if (this.serverUrl) {
            return fetch(request)
                .then(response => FetchUtils.parseFetchResponse(response))
                .catch(error => Promise.reject(error));
        }
        LogService.error(LOG_TAG, "post", "no server instance");
        return Promise.reject(ErrorUtils.parseErrorAndReturnPayload("no server instance"));
    }

    put(relativeUrl, body) {
        const request = new Request(this.serverUrl + relativeUrl, {
            method: "PUT",
            headers: new Headers({
                accept: "application/json",
                "Content-Type": "application/json",
                authorization: "Bearer " + this.token
            }),
            body: body
        });

        if (this.serverUrl) {
            return fetch(request)
                .then(response => FetchUtils.parseFetchResponse(response))
                .catch(error => Promise.reject(error));
        }
        LogService.error(LOG_TAG, "put", "no server instance");
        return Promise.reject(ErrorUtils.parseErrorAndReturnPayload("no server instance"));
    }

    delete(relativeUrl) {
        const request = new Request(this.serverUrl + relativeUrl, {
            method: "DELETE",
            headers: new Headers({
                accept: "application/json",
                authorization: "Bearer " + this.token
            }),
        });

        if (this.serverUrl) {
            return fetch(request)
                .then(response => FetchUtils.parseFetchResponse(response))
                .catch(error => Promise.reject(error));
        }
        LogService.error(LOG_TAG, "delete", "no server instance");
        return Promise.reject(ErrorUtils.parseErrorAndReturnPayload("no server instance"));
    }
}

export default new SandBoxServerRequest();